module.exports = __webpack_public_path__ + "static/the-russia-house-58a7662cec3659bad66428fb461ce61c.jpg";